<template>
    <p v-if="haveCreditors != null && !haveCreditors" class="text-center">
        You Don’t Have Any <strong>Creditors Reporting</strong>. Please Import A <strong>Credit Report</strong>.
    </p>
    <div v-show="isInputFormActive && haveCreditors" class="row text-center mx-auto prev-item justify-content-center">
        <pagination :data="creditors" @pagination-change-page="getCreditors" />
    </div>
    <!-- Card Advance -->
    <div v-show="isInputFormActive && haveCreditors" class="row match-height">
        <!-- Developer Meetup Card -->
        <template v-for="creditor in creditors.data">
            <div class="col-lg-3 col-md-3 col-12">
                <div class="card card-developer-meetup">
                    <div class="card-body">
                        <div class="meetup-header d-flex align-items-center">
                            <div class="my-auto">
                                <h4 class="card-title mb-25">{{ creditor.creditor_name }}</h4>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="phone" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Phone</h6>
                                <small>{{ creditor.phone }}</small>
                            </div>
                        </div>
                        <div class="media">
                            <div class="avatar bg-light-primary rounded mr-1">
                                <div class="avatar-content">
                                    <i data-feather="map-pin" class="avatar-icon font-medium-3"></i>
                                </div>
                            </div>
                            <div class="media-body">
                                <h6 class="mb-0">Address</h6>
                                <small>{{ creditor.address }}</small>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <a href="#" @click="selectedCreditor(creditor)" type="button" class="btn btn-primary btn-block">Create</a>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </div>
    <section v-show="!isInputFormActive">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-header p-0 mb-50 mx-auto">
                        <a class="go-back" @click="goBack" >{{ localizationStore.translate("letter.create.back.button.text") }}</a>
                    </div>
                    <div class="card-content">
                        <div class="mb-2">
                            <label for="common-remedies">Common Remedies</label>
                            <Select2
                                v-model="selectedRemedy"
                                :options="remedies"
                                :settings="{ multiple: true }"
                                @change="myChangeEvent($event)"
                                @select="mySelectEvent($event)"
                            />
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <h4>APPEND CLIENT DOCUMENTS</h4>
                                <div class="display-box mb-1">
                                    <div class="ml-2">
                                        <input
                                            class="custom-control-input"
                                            type="checkbox"
                                            name="append_affidavit"
                                            value="1"
                                            tabindex="4"
                                            v-model="checkbox"
                                            id="append_affidavit"

                                        />
                                        <label class="custom-control-label" for="Make_the_recipient_the_sender" @click="changeCheckbox">
                                            ID Theft Affidavit
                                        </label>
                                    </div>

                                </div>

                            </div>
                        </div>
                        <!-- change this to send ajax request to create letter -->
                        <form>
                            <!-- <input type="hidden" name="_token" :value="csrf">
                            <input type="text" class="form-control" id="creditbureau" name="creditbureau" :value="creditorSelected.id" hidden> -->
                            <div class="col-md-12">
                                <div id="editor">
                                    <editor
                                        id="CeaseDesistLetter"
                                        v-model="CeaseDesistLetter"
                                        :api-key="settingStore.tinymce.api_key"
                                        :init="settingStore.tinymce.configuration"
                                    />
                                </div>
                                <div class="d-flex justify-content-center my-1">
                                    <!-- create -->
                                    <button class="btn btn-sm-block btn-primary" type="button" name="editorType" value="1" @click.once="createLetter()">
                                        {{ localizationStore.translate("letter.left.submit.button.text") }}
                                    </button>
                                    <button
                                        id="letter-rewrite"
                                        class="btn btn-outline-primary ml-1"
                                        @click="spin"
                                        type="button"
                                    >
                                        {{ localizationStore.translate("spin.letter.button.text") }}
                                        <b-popover
                                            target="letter-rewrite"
                                            placement="top"
                                            triggers="hover"
                                            :html="true"
                                        >
                                            <template #title>
                                                {{ localizationStore.translate("chat.pricing.title") }}
                                            </template>
                                            <div class="row">
                                                <div class="col-12">
                                                    <p v-if="planStore.openAI.serviceCharges.type == planStore.openAI.serviceCharges.fixed">
                                                        {{ localizationStore.translate("chat.pricing.message", { credit: planStore.getPrice('letter_rewrite') }) }}
                                                    </p>
                                                    <p v-else>
                                                        {{ localizationStore.translate("chat.pricing.dynamic.message") }}
                                                    </p>
                                                </div>
                                            </div>
                                        </b-popover>
                                    </button>
                                    <button
                                        data-toggle="modal"
                                        data-target="#chat-modal"
                                        class="btn btn-outline-primary mx-1"
                                        type="button"
                                    >
                                        {{ localizationStore.translate("chat.button.title") }}
                                    </button>
                                    <button
                                        data-toggle="modal"
                                        data-target="#top-up-modal"
                                        class="btn btn-outline-primary"
                                        type="button"
                                    >
                                        {{ localizationStore.translate("spin.purchase.button.text") }}
                                    </button>
                                </div>
                                <div class="row">
                                    <spinner ref="spinner" :user-info='userInfo' :editor-ref='editorRefSingle' />
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
        <div ref="editorRefSingle" hidden>
            <div style="page-break-after: always; padding: 15px 50px;">
                <p>{{ userStore.user.tdate }}</p>
                <p style="display: inline-block;">
                    {{ userStore.user.firstname }} {{ userStore.user.lastname }}
                    <br />
                    {{ userStore.user.address }}
                    <br />
                    {{ userStore.user.city }}, {{ userStore.user.state }} {{ userStore.user.zipcode }}
                </p>
                <p style="display: inline-block; float: right;">
                    {{ creditorSelected.address_line }}
                    <br />
                    {{ creditorSelected.address }}
                    <br />
                    {{ creditorSelected.city }}, {{ creditorSelected.state }} {{ creditorSelected.zipcode }}
                </p>
                <p>
                    <strong>CEASE AND DESIST</strong>
                    {{ creditorSelected.creditor_name }}
                </p>
                <p class="letter-content">
                    Pursuant to 15 USC 1692c.(c) I am notifying you in writing that I refuse to pay this alleged debt, and I am demanding that you cease all forms of communication with me through any and all mediums.
                </p>
                <p class="letter-content">
                    Pursuant to 15 USC 1692c.(c)(2) I am invoking my specified remedy as a consumer, and the original creditor I am demanding all of the following:
                </p>
                <ul>
                    <li v-for="remedy in selectedRemedy">{{ remedy }}</li>
                </ul>
                <p> Best regards,
                    <br />
                    {{ userStore.user.firstname }} {{ userStore.user.lastname }}
                    <br />
                    <br />
                    <br />
                    Signature
                </p>
            </div>
            <p class="page_break"></p>
        </div>
    </section>
</template>
<script>
  import { reactive, computed, ref } from 'vue'
  import LaravelVuePagination from 'laravel-vue-pagination';
  import Select2 from 'vue3-select2-component';
  import { useLocalizationStore } from '../../stores/LocalizationStore.js'
  import { useUserStore } from '../../stores/UserStore.js'
  import { useLetterStore } from '../../stores/LetterStore.js'
  import { usePlanStore } from '../../stores/PlanStore.js'
  import { useSettingStore } from '../../stores/SettingStore.js'
  import Editor from '@tinymce/tinymce-vue'
  import { BPopover } from 'bootstrap-vue-3'
  export default {
    props: {
        csrf: {
            type: String
        },
        propCreditBureaus: {
            type: [Array, Object]
        },
        userInfo: {
            type: [Array, Object]
        },
    },
    components: {
        'pagination': LaravelVuePagination,
        Select2,
        Editor
    },
    setup(props) {
        return {
            creditBureaus: props.propCreditBureaus,
            editorRefSingle: ref(null),
            date: ref(null),
            isInputFormActive: ref(true),
            haveCreditors: ref(null),
            localizationStore: useLocalizationStore(),
            userStore: useUserStore(),
            letterStore: useLetterStore(),
            planStore: usePlanStore(),
            settingStore: useSettingStore(),
            CeaseDesistLetter:ref(null),
            userInfo:reactive({}),
            creditorSelected:reactive([]),
            checkbox:ref(false)
        };
    },
    watch: {
        'userStore.user'(value) {
            if (value != null) {
                this.date = value.tdate
                this.userInfo = value
            }
        },
    },
    created() {
    },
    data() {
        return {
            // Our data object that holds the Laravel paginator data
            creditors: {},
            selectedRemedy: '',
            remedies: [
                'Pay the attached invoice and compensate me.',
                'Deletion from all consumer reports.',
                'Clear out payment history.',
                'Grant me my title lien free.',
                'Change all payment history to paid as agreed or on-time.',
                'Zero out on my open ended consumer plan balance monthly.',
                'Do not close my account(s) without authorized permission.',
                'Do not seize or attempt to seize anything in my possession.',
                'Remove all remarks or comments off my consumer report.',
                'Pay the attached bill of particulars for every violation labeled in the attached exhibits.',
                'Zero out the balance on this account.',
                'Return requested documents so I can properly assess the validity of any debt.',
                'Cease and rescind use of my intellectual property, my signature.'
            ]
        }
    },
    mounted() {
        let $this = this;
        if(!_.isEmpty($this.userStore.user)){
            $this.date = $this.userStore.tdate
            $this.userInfo = $this.userStore.user
        }else{
            $this.userStore.fetchUser();
        }
        this.getCreditors();
    },
    computed: {
    },
    methods: {
        getCreditors(page = 1) {
            let $this = this;
            let params = {
                type: 1,
                letter: this.letterStore.getId($this.$route.params.letter)
            };
            if ($this.$route.params.client) {
                params.client = $this.$route.params.client
            }
            if ($this.$route.params.team) {
                params.team = $this.$route.params.team
            }
            const listCreditBureau = $this.$router.resolve({
                name: 'disputes-creditBureau',
                params: params
            });
            axios.get(listCreditBureau.href + '?page=' + page)
                .then(response => {
                    this.creditors = response.data;
                    if (this.creditors.data.length > 0) {
                        this.haveCreditors = true;
                    }
                    else {
                        this.haveCreditors = false;
                    }
                });
        },
        createLetter(){
            let $this = this;
            let params = { letter: this.$route.params.letter };
            if (this.$route.params.client) {
                params.client = this.$route.params.client
            }
            if (this.$route.params.team) {
                params.team = this.$route.params.team
            }
            const createLetterRoute = this.$router.resolve({
                name: 'create-letter',
                params: params
            });
            let payload = {
                'letter_id' : this.letterStore.getId(this.$route.params.letter),
                'creditbureau' : this.creditorSelected.id,
                'editor' : this.CeaseDesistLetter,
                'editorType':1,
                append_affidavit : $this.checkbox,
            }
            axios.post(createLetterRoute.href, payload)
            .then(function (response) {
                if(response.data.error == true) {
                    toastr.error(response.data.message, 'Error!');
                    return;
                }
                toastr.success(response.data.message, 'Success!');
                setTimeout(() => {
                    if($this.userStore.user.isDIY){
                        $this.$router.push({ name: 'disputes-report' });
                        return;
                    }
                    window.location.href = response.data.data.url;
                }, 3000)
            })
            .catch(function (error) {
                console.log(error);
            });


        },
        reloadContent(){
            this.CeaseDesistLetter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
        },
        selectedCreditor(creditor) {
            this.creditorSelected = creditor;
            setTimeout(() => {
                this.CeaseDesistLetter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                this.isInputFormActive = !this.isInputFormActive;
            }, "100");
            this.reloadContent()
        },
        goBack: function () {
            this.isInputFormActive = !this.isInputFormActive;
        },
        myChangeEvent(val){
            setTimeout(() => {
                this.CeaseDesistLetter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
            // tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
        },
        mySelectEvent({id, text}){
            setTimeout(() => {
                this.CeaseDesistLetter = this.$refs.editorRefSingle && this.$refs.editorRefSingle.innerHTML;
                // tinymce.get('editor').setContent(this.editorRefSingle.innerHTML);
            }, "100");
            // tinymce.activeEditor.setContent(this.editorRefSingle.innerHTML);
        },
        spin() {
            this.$refs.spinner.spin(tinymce.get('CeaseDesistLetter'))
        },
        changeCheckbox(){
            this.checkbox = !this.checkbox
        }
    }
  };
</script>
<style scoped>
.card-developer-meetup {
    background: #f3f2f7;
}
</style>
